<template>
  <div>
    <a @click="expanded = !expanded"
       class="panel-block folder">
      <span class="panel-icon">
        <font-awesome-icon icon="folder"></font-awesome-icon>
      </span>
      {{ folder.name }}
    </a>
    <div v-show="expanded || forceExpanded">
      <template v-for="(band,key) in folder.contents">
        <band v-show="band.show"
              :key="key"
              :band="band"
              :forceExpanded="forceExpanded"></band>
      </template>
    </div>
  </div>
</template>

<script>
import Band from '@/components/Band';

export default {
  name: 'Folder',
  components: {
    Band
  },
  props: {
    folder: {
      type: Object,
      default () {
        return {};
      }
    },
    forceExpanded: false
  },
  data () {
    return {
      expanded: false
    };
  }
};
</script>

<style scoped>
.folder {
  border-top-width: 0px !important;
}
</style>
